// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {EventBus} from './../../../mixins/event_bus/EventBus'

@Component({
    name: 'Radio',
    mixins: [
        template,
    ]
})
export class Radio extends mixins(EventBus) {

    public get themeMap() {
        const themeMap = {
            default: 1,
            secondary: 2,
            'inline-default': 3,
            'inline-secondary': 4,
            'vertical': 1
        }

        return themeMap[this.parentTheme] ? themeMap[this.parentTheme] : themeMap['default']
    }

    public get themeClass() {
        return `${this.$appPrefix}-radio--${this.theme ? this.theme : 'default'} wb-e-radio-${this.themeMap}__wrapper`
    }

    public get disabledClass() {

        return this.disabled || this.parentDisabled ? `${this.$appPrefix}-radio--disabled wb-e-radio-${this.themeMap}--disabled` : ''
    }

    public checked: boolean = false

    @Prop()
    public theme!: string

    @Inject({ from: 'radioGroupDisabled', default: false})
    public parentDisabled!: boolean

    @Inject({ from: 'radioGroupTheme', default: null})
    public parentTheme!: string

    @Prop([String, Number, Boolean])
    public value!:any

    @Prop({type: [String, Number, Boolean], default: undefined})
    public trueValue!:any

    @Prop()
    public label!: string

    @Prop()
    public id!: string

    @Prop()
    public name!: string

    @Prop({default: false})
    public disabled!: boolean

    @Prop({default: "0"})
    public tabindex!: string

    public created () {
        this.$on('change', this.handleValueChange)
    }

    public destroyed() {
        this.$off('change', this.handleValueChange)
    }

    public handleValueChange(value: any) {
        if( this.trueValue != undefined ) {
            this.checked = value === this.trueValue
        }
        else
        {
            this.checked = value === this.value
        }
        this.$emit('input', this.checked)
    }

    public handleChange(e) {
        this.checked = e.target.checked
        this.$emit('input', e.target.checked)
        if ( this.checked ) {
            if( this.trueValue != undefined ) {
                this.dispatch('RadioGroup', 'change', [this.trueValue])
            }
            else
            {
                this.dispatch('RadioGroup', 'change', [this.value])
            }
        }
    }
}